
<ion-app>

  <ion-header *ngIf="offlineMode" class="offline-header ion-no-border">
    <shared-offlinemode ></shared-offlinemode>
  </ion-header>
  
  <ion-router-outlet></ion-router-outlet>
  
  <ccl-offline-overlay-v2 [showConnectionLost]="mqttOffline && !offlineMode" [showSettingsButton]="false">
  </ccl-offline-overlay-v2>



  <!-- <cpg-sip-popup></cpg-sip-popup> -->

</ion-app>